export const FILE_ACTION = {
  RESET_UPLOAD_FILE_STATE: "RESET_UPLOAD_FILE_STATE",
  REQUEST: "UPLOAD_FILE_REQUEST",
  ERROR: "UPLOAD_FILE_ERROR",
  RESPONSE: "UPLOAD_FILE_RESPONSE",
};

export const GETFILE_ACTION = {
  RESET_FILE_STATE: "RESET_FILE_STATE",
  REQUEST: "GET_FILE_REQUEST",
  ERROR: "GET_FILE_ERROR",
  RESPONSE: "GET_FILE_RESPONSE",
};
export const DOWNLOADFILE_ACTION = {
  RESET_FILE_STATE: "RESET_FILE_STATE",
  REQUEST: "DOWNLOAD_FILE_REQUEST",
  ERROR: "DOWNLOAD_FILE_ERROR",
  RESPONSE: "DOWNLOAD_FILE_RESPONSE",
};

export const setResetStatedownloadFile = () => ({
  type: DOWNLOADFILE_ACTION.RESET_FILE_STATE,
  data: undefined
});

export const requestDownloadFileAction = (id, fileId,action, fileName, type) =>({
  type: DOWNLOADFILE_ACTION.REQUEST,
  data: {id, fileId, action, fileName, type}
})
export const responseDownloaloadFileAction = (res) => ({
  type: DOWNLOADFILE_ACTION.RESPONSE,
  data: res
});

export const errorDownloadFileAction = (err) => ({
  type: DOWNLOADFILE_ACTION.ERROR,
  data: err
});


export const setResetStateuploadFile = () => ({
    type: FILE_ACTION.RESET_UPLOAD_FILE_STATE,
    data: undefined
  });
  
  export const requestUploadFileAction = (params) =>({
    type:FILE_ACTION.REQUEST,
    data: params
  })
  export const responseUploadFileAction = (res) => ({
    type: FILE_ACTION.RESPONSE,
    data: res
  });
  
  export const errorUploadFileAction = (err) => ({
    type: FILE_ACTION.ERROR,
    data: err
  });

  export const setResetStateFile = () => ({
    type: GETFILE_ACTION.RESET_FILE_STATE,
    data: undefined
  });

  export const requestGetFileAction = (params) =>({
    type:GETFILE_ACTION.REQUEST,
    data: params
  })
  export const responseGetFileAction = (res) => ({
    type: GETFILE_ACTION.RESPONSE,
    data: res
  });
  
  export const errorGetFileAction = (err) => ({
    type: GETFILE_ACTION.ERROR,
    data: err
  });